<template>
  <el-form style="background: white" :model="outboundForm" :rules="rules" ref="ruleForm">
    <el-form-item label="所属项目" prop="projectId">
      <el-select :disabled="_disabled" size="small" v-model="outboundForm.projectId" filterable placeholder="请选择所属项目">
        <el-option :label="item.projectName" :value="item.projectId" v-for="(item, index) of projectList" :key="index"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="出库仓库" prop="warehouseId">
      <el-select :disabled="_disabled || !outboundForm.projectId" size="small" v-model="outboundForm.warehouseId" filterable placeholder="请选择仓库">
        <el-option :label="item.warehouseName" :value="item.warehouseId" v-for="(item, index) of warehouseData" :key="index"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="出库日期" prop="checkoutDate">
      <el-date-picker :disabled="_disabled" v-model="outboundForm.checkoutDate" value-format="yyyy-MM-dd" type="date" placeholder="请选择出库日期"></el-date-picker>
    </el-form-item>
    <el-form-item label="领用人" prop="checkoutUser">
      <el-select :disabled="_disabled || !outboundForm.projectId" v-model="outboundForm.checkoutUser" filterable placeholder="请选择领用人">
        <el-option :label="item.userName" :value="item.userId" v-for="(item, index) in projectUserList" :key="index"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="出库说明" prop="checkoutExplain">
      <el-input :disabled="_disabled" size="small" type="textarea" maxlength="300" :autosize="{ minRows: 4, maxRows: 8 }"
        v-model="outboundForm.checkoutExplain" placeholder="请输入出库说明"></el-input>
    </el-form-item>

    <el-form-item label="出库物料明细" prop="detailedList"></el-form-item>

    <el-table class="global-table material-table" :data="outboundForm.detailedList">
      <el-table-column label="物料分类" prop="materialTypeName"></el-table-column>
      <el-table-column label="物料名称" prop="materialName"></el-table-column>
      <el-table-column label="规格型号" prop="specifications"></el-table-column>
      <el-table-column label="品牌名称" prop="brand"></el-table-column>
      <el-table-column label="单价" prop="unitPrice"></el-table-column>
      <el-table-column label="单位" prop="company"></el-table-column>
      <el-table-column label="剩余库存" prop="stock"></el-table-column>
      <el-table-column prop="checkoutType" width="200px">
        <template slot="header">
            <span style="color: #f00;font-size: 14px;margin-right: 4px;">*</span>出库类型
        </template>
        <template v-slot="{ row, $index }">
          <el-form-item label-width="'0'" :prop="'detailedList.' + $index + '.checkoutType'"
            :rules='rules.checkoutType'>
            <el-select :disabled="_disabled" v-model="row.checkoutType" placeholder="请选择">
              <el-option v-for="item in checkoutTypeData" :key="item.dicId" :label="item.dicValue"
                :value="item.dicValue"></el-option>
            </el-select>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column prop="operationStock" width="200px">
        <template slot="header">
            <span style="color: #f00;font-size: 14px;margin-right: 4px;">*</span>出库数量
        </template>
        <template v-slot="{ row, $index }">
          <el-form-item label-width="'0'" :prop="'detailedList.' + $index + '.operationStock'"
            :rules='rules.operationStock'>
            <el-input :disabled="_disabled" maxlength="30" v-model="row.operationStock" placeholder="请输入"></el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column label="用途说明" prop="bak" width="200px">
        <template v-slot="{ row }">
          <el-input :disabled="_disabled" v-model.number="row.bak" placeholder="请输入" maxlength="50"/>
        </template>
      </el-table-column>
      <el-table-column v-if="!_disabled" label="操作" prop="">
        <template v-slot="{ $index }">
          <el-button class="del-btn" type="text" @click="deleteDetailedList($index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-button v-if="!_disabled" type="text" class="mt10" icon="el-icon-plus" @click="addOutbound">新增出库物料</el-button>

    <el-dialog title="物料清单" :visible.sync="dialogVisible" :modal-append-to-body="false"
  :append-to-body="true" width="800px" :close-on-click-modal="false">
      <el-form class="global-form" inline label-width="100px">
        <el-form-item prop="materialName">
          <el-input v-model="searchForm.materialName" clearable placeholder="请输入产品名称"></el-input>
        </el-form-item>
      <el-form-item prop="materialTypeId">
        <el-cascader v-model="searchForm.materialTypeId" :options="materialTypeData" :props="{ checkStrictly: true, emitPath: false, children: 'childNode', label: 'materialTypeName', value: 'materialTypeId' }" placeholder="请选择物料分类" clearable></el-cascader>
      </el-form-item>
        <el-form-item>
          <el-select v-model="searchForm.supplierId" clearable placeholder="供应商名称">
            <el-option
                v-for="item in supplierData"
                :key="item.supplierId"
                :label="item.supplierName"
                :value="item.supplierId"
              ></el-option>
            </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSearchWorkOrder">查询</el-button>
        </el-form-item>
      </el-form>
        <el-table ref="table" @selection-change="selectionLineChangeHandle" class="global-table" reserve-selection = true :row-key="getRowKeys"  :data="materialData">
          <el-table-column reserve-selection type="selection" :selectable="selectable"></el-table-column>
          <el-table-column prop="materialName" label="物料名称" show-overflow-tooltip></el-table-column>
          <el-table-column prop="specifications" label="规格型号" show-overflow-tooltip></el-table-column>
          <el-table-column prop="brand" label="品牌名称" show-overflow-tooltip></el-table-column>
          <el-table-column prop="materialTypeName" label="物料分类" show-overflow-tooltip></el-table-column>
          <el-table-column prop="supplierName" label="供应商名称" show-overflow-tooltip></el-table-column>
          <el-table-column prop="latestStorageTime" label="入库日期" min-width="90" show-overflow-tooltip></el-table-column>
          <el-table-column prop="stock" label="剩余库存" show-overflow-tooltip></el-table-column>
        </el-table>

      <global-pagination
        @size-change="getMaterialData"
        @current-change="getMaterialData"
        :current-page.sync="page"
        :page-size.sync="size"
        :total="total">
      </global-pagination>
      <el-button type="primary" @click="confirm">确定</el-button>
      <el-button @click="dialogVisible = false">取消</el-button>
    </el-dialog>
  </el-form>
</template>
<script>
//用来进行测试外部表单组件的vue表单，不需要的话可以删除
import OuterFormMixin from './OuterFormMixin'

const operationStockV = (rule, value, callback) => {
  const reg = /^[1-9][0-9]*$/
  if (!reg.test(value) || Number(value) > 9999999) {
    return callback(new Error('请输入1到9999999整数'))
  } else {
    return callback()
  }
}
export default {
  name: "OutboundHwnysForm",
  mixins: [OuterFormMixin],
  data(){
    return {
      disabled: false,
      outboundForm: {
        projectId: '',
        warehouseId: '',
        checkoutDate: '',
        checkoutUser: '',
        checkoutExplain: '',
        imgList: [],
        fileList: [],
        detailedList: []
      },
      rules: {
        projectId: [
          { required: true, message: '请选择所属项目', trigger: 'blur' }
        ],
        warehouseId: [
          { required: true, message: '请选择出库仓库', trigger: 'blur' }
        ],
        checkoutDate: [
          { required: true, message: '请选择出库日期', trigger: 'blur' }
        ],
        checkoutUser: [
          { required: true, message: '请选择领用人', trigger: 'blur' }
        ],
        detailedList: [
          { required: true, type: 'array', message: '请添加出库物料明细', trigger: 'blur' }
        ],
        checkoutType: [
          { required: true, message: '请选择出库类型', trigger: 'change' }
        ],
        operationStock: [
          { required: true, message: '请输入出库数量', trigger: 'change' },
          { validator: operationStockV, trigger: ['blur', 'change'] }
        ]
      },
      loading: false,
      searchForm: {
        materialName: '',
        supplierId: '',
        materialTypeId: '',
        stock: '1'
      },
      dialogVisible: false,
      page: 1,
      total: 0,
      size: 10,
      selectItems: [], // 选中的临时物料
      materialData: [], // 物料列表
      warehouseData: [], // 仓库
      projectUserList: [], //领用人列表
      supplierData: [], // 供应商类型
      materialTypeData: [],
      checkoutTypeData: []//出库类型
    }
  },
  computed: {
    projectList() {
      return this.$store.state.projectList
    }
  },
  watch: {
    'outboundForm.projectId'() {
      if(!this._disabled){
        this.outboundForm.checkoutUser = ''
        this.outboundForm.warehouseId = ''
        this.outboundForm.detailedList = []
      }

      // 重置领用人
      this.$axios.get(this.$apis.project.selectYhProjectUserByList, {
        projectId: this.outboundForm.projectId
      }).then(res => {
        this.projectUserList = res || []
      })

      // 重置仓库
      this.$axios.get(this.$apis.material.selectYhWarehouseByList, {
        projectId: this.outboundForm.projectId
      }).then(res => {
        this.warehouseData = res.list || []
      })
    }
  },
  mounted() {
    this.formInit(this.outboundForm, 'ruleForm')
    this.loadCheckoutType()
    this.loadMaterialType()
    this.loadSupplierType() // 加载供应商
  },
  methods: {
    loadCheckoutType() {
      this.$axios.get(this.$apis.common.selectDicByList, {
        dicType: 'checkoutType'
      }).then((res) => {
        this.checkoutTypeData = res.checkoutType || []
      })
    },
    loadMaterialType () {
      this.$axios.get(this.$apis.material.selectYhMaterialTypeByList).then(res => {
        this.materialTypeData = res || []
      })
    },
    // 加载供应商
    loadSupplierType () {
      this.$axios.get(this.$apis.material.selectYhSupplierByPage).then(res => {
        this.supplierData = res.list || []
      })
    },
    getMaterialData () {
      this.$axios.get(this.$apis.material.selectYhMaterialByPage, {
        ...this.searchForm,
        page: this.page,
        size: this.size,
        warehouseId: this.outboundForm.warehouseId
      }).then(res => {
        this.total = res.total || 0
        this.materialData = res.list || []
      })
    },
    addOutbound() {
      if (!this.outboundForm.projectId) {
        this.$message.warning('请先选择项目')
        return
      }
      if (!this.outboundForm.warehouseId) {
        this.$message.warning('请选择出库仓库')
        return
      }

      if (!this.outboundForm.detailedList) {
        this.outboundForm.detailedList = [];
      }

      this.page = 1
      this.dialogVisible = true
      this.getMaterialData()
      this.$nextTick(() => {
        this.$refs.table.clearSelection()
        this.outboundForm.detailedList.forEach(item => {
          this.$refs.table.toggleRowSelection(item, true)
        })
      })
    },
    deleteDetailedList(index) {
      this.outboundForm.detailedList.splice(index, 1)
    },
    // 记录选择的物料，翻页不影响
    getRowKeys(row) {
      return row.materialId
    },
    onSearchWorkOrder () {
      this.page = 1
      this.getMaterialData()
    },
    selectionLineChangeHandle (val) {
      this.selectItems = val
    },
    // 选择工单
    confirm () {
      let arr = []
      arr = this.selectItems.filter((item) => {
        return this.outboundForm.detailedList.every((k) => {
          return item.materialId !== k.materialId
        })
      })

      for(var i in arr){
        if(this.outboundForm.detailedList.some(item => item.materialId == arr[i].materialId)){
          this.$message.warning('每种物料只能选择一次!')
          return
        }
      }

      this.outboundForm.detailedList = [...this.outboundForm.detailedList, ...arr]
      this.dialogVisible = false
    },
    selectable (row) {
      return !this.outboundForm.detailedList.some((item) => item.materialId === row.materialId)
    }
  }
}
</script>
<style scoped lang="less">
::v-deep .material-table {

    .el-input,
    .el-select,
    .el-cascader {
      width: 100% !important;
    }

    .el-form-item {
      margin-bottom: 0
    }

    ;

    .el-form-item--small.el-form-item {
      margin-bottom: 0
    }

    .cell {
      height: 62px;
      display: flex;
      align-items: center
    }
  }
</style>
